import styled from 'styled-components';
import { FONTS } from '@app/src/ui';

export const TableContainer = styled.div`
  font-family: ${FONTS.MONTSERRAT};
  font-size: 12px;
  margin-bottom: 40px;

  &.contenedor {
    overflow-x: auto;
  }
`;

export const Table = styled.table`
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
  border: 1px solid #ddd;
`;

export const Th = styled.th`
  text-align: center;
  padding: 8px;
  border: 1px solid #ddd;
  background-color: #000;
  color: #fff;
`;

export const Td = styled.td`
  text-align: center;
  padding: 8px;
  border: 1px solid #ddd;

  &.black {
    background-color: #000;
    color: #fff;
  }
`;